import React from 'react';
import {Card} from 'primereact/card';
import InnerHtml from '../../../../components/inner-html';
import {useHistory} from 'react-router-dom';
import { Utils } from '../../../../shared/utils/Utils';

interface Props {
  evento: any;
}

export default function MeuEventoCard({evento}: Props) {
  const history = useHistory();
  const header = () => <>
    <div className="flex justify-content-end mr-3">
      <label className="titulo-institucional">{evento.qtdContribuicoesPorContribuinte} contribuições</label>
    </div>
  </>
  return (
    <>
      <div className="flex" style={{cursor: 'pointer'}} onClick={() => history.push('/evento/visualizar', {id: evento.id})}>
        <Card
          header={() => header()}>
          <div className="card-wrapper">
            <img src="/images/video-cover-audiencia-publica.png" />
            <h3 className="mt-2">{evento.numero}</h3>
            <label className="mt-2">{evento.tipoEvento}</label>
            <div>
              <p>{evento.periodoValidade}</p>
              <div className="limite-descricao">
                <InnerHtml value={Utils.formataTextoTamanhoMaximo(evento.descricao, 150)} />
              </div>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
}
